import moment from 'moment';

/**
 * @param {object} filters
 * @returns {object}
 */
export const mapVehicleFiltersForBackend = (filters) => {
  if (!filters) {
    return {
      carrier_is_blocked: 'False',
      ..._mapVehicleTypeFilter({
        box_van: '',
        rigid_truck: '',
        semi_trailer: '',
        trailer: '',
        van: '',
      }),
    };
  }
  const {
    height,
    width,
    needs_lateral_loading,
    needs_liftgate,
    needs_top_load,
    pallets,
    route,
    weight,
    plate_number,
    needs_box_van: box_van,
    needs_rigid_truck: rigid_truck,
    needs_semi_or_full_trailer: semi_trailer,
    needs_trailer: trailer,
    needs_van: van,
    carrier,
    date,
    sorting,
    postalcode,
    engine_type,
    euro_category,
  } = filters;
  return {
    ...{ carrier_is_blocked: 'False' },
    ...(needs_liftgate && { has_liftgate: 'True' }),
    ...(needs_top_load && { has_superior_loading: 'True' }),
    ...(needs_lateral_loading && { has_lateral_loading: 'True' }),
    ...(pallets && { max_pallets: pallets }),
    ...(weight && { max_weight: weight }),
    ...(height && { max_height: height }),
    ...(width && { max_width: width }),
    ...(route && { route: route.replace('-', '->') }),
    ...(plate_number && { plate_number: plate_number }),
    ...(carrier && { carrier }),
    ...(sorting && { ordering: sorting }),
    ...(postalcode && { zipcode: postalcode }),
    ...(date && _getDateRange(date)),
    ...(engine_type && { engine_type }),
    ...(euro_category && { euro_category }),
    ..._mapVehicleTypeFilter({
      box_van,
      rigid_truck,
      semi_trailer,
      trailer,
      van,
    }),
  };
};

const _getDateRange = (from) => {
  const options = {
    ONE_WEEK: { amount: 1, type: 'week' },
    ONE_MONTH: { amount: 1, type: 'month' },
    THREE_MONTHS: { amount: 3, type: 'month' },
    SIX_MONTHS: { amount: 6, type: 'month' },
    ANY: { amount: 4, type: 'year' },
  };

  if (!options[from]) {
    return {};
  }

  return {
    last_carrier_journey_from: moment()
      .subtract(options[from].amount, options[from].type)
      .format('YYYY-MM-DD'),
    last_carrier_journey_to: moment().format('YYYY-MM-DD'),
  };
};

/**
 * @param {object} vehicleTypeFilters
 * @returns {object} - If vehicle_type filter is not used returns a query for all
 *          the vehicle types, otherwise returns the vehicle_types selected.
 */
export const _mapVehicleTypeFilter = (vehicleTypeFilters) => {
  if (!vehicleTypeFilters) {
    return;
  }

  const filtersArray = Object.keys(vehicleTypeFilters);
  const definedFilters = filtersArray.filter((type) => vehicleTypeFilters[type] !== undefined);
  const filtersToUse = definedFilters.length > 0 ? definedFilters : filtersArray;

  return { vehicle_type: _createQueryString(filtersToUse) };
};

/**
 * @param {object} filters
 * @returns {string}
 */
const _createQueryString = (filters) => {
  const prefix = `&vehicle_type=`;

  return filters.reduce((acc, type, i) => (i === 0 && `${type}`) || `${acc}${prefix}${type}`, '');
};
